// CU-86d45b2zn — client for commerce's customer-safe order history. Ownership is the signed token on the server, so
// only page parameters are ever sent; the projection carries no ownership, customer-identity or finance fields.
import { ENV } from "../../config/runtimeEnv";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_COMMERCE_SERVER;

export interface CustomerOrderItem {
	item_id: number;
	product_name: string | null;
	variant_title: string | null;
	quantity: number;
	// CU-86d45b2zn: commerce's decimal strings, e.g. "42.50".
	unit_price: string;
	line_total: string;
}

export interface CustomerOrder {
	order_id: number;
	// Shopify order number when the order came from Shopify, otherwise the local reference.
	reference: string;
	// Calendar date, YYYY-MM-DD.
	order_date: string | null;
	status: string;
	total_amount: string;
	is_shopify_order: boolean;
	financial_status: string | null;
	fulfillment_status: string | null;
	shipping_total: string | null;
	tax_total: string | null;
	items: CustomerOrderItem[];
}

export interface CustomerOrdersPage {
	data: CustomerOrder[];
	pagination: {
		current_page: number;
		per_page: number;
		total_pages: number;
		total_items: number;
	};
}

export interface CustomerOrdersQuery {
	page?: number;
	perPage?: number;
}

export const fetchCustomerOrders = async ({ page = 1, perPage = 10 }: CustomerOrdersQuery = {}): Promise<CustomerOrdersPage> => {
	const response = await http.get(`${API_BASE_URL}/customer/orders`, {
		params: {
			page,
			per_page: perPage,
		},
	});

	return response.data;
};
